import React from 'react';
import Page from '../components/Page';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Label,
  Row,
  Table,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Form,
  FormFeedback,
  FormGroup,
  FormText,
  Input,
} from 'reactstrap';
import axios from '../utils/posAxios';
import StorageService from '../services/StorageService';
import {
  MdCameraAlt,
  MdFace,
  MdDone,
  MdClear,
  MdCreate,
  MdAdd,
} from 'react-icons/md';
import { BsPlusSquareFill } from 'react-icons/bs';
import NotificationSystem from 'react-notification-system';
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants';
import { Redirect } from 'react-router';
import classnames from 'classnames';
import PosShippingForm from '../components/PosShippingForm';
import { IconContext } from 'react-icons/lib';
import PosPromoTable from './PosPromoTable';
import PosEmailAlertTable from './PosEmailAlertTable';

class PosEmailAlertForm extends React.Component {
  _isMounted = true;
  constructor(props) {
    super(props);
    this.state = {
      isEdit: false,
      isGlobal: true,
      email: '',
      report_type: '',
      store_id: '',
    };
  }

  componentDidMount() {
    if (this.props.data.isEdit) {
      let email = this.props.data.selectedId;
      let report_type = this.props.data.selectedData;
      this.setState({
        email: email,
        report_type: report_type,
        isEdit: true,
      });
    }
    this.setState({
      store_id: this.props.data.store_id,
    });
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  EmailAlert = () => {
    const user = StorageService.getSession('user_info');
    const comp = StorageService.getSession('selected_org');
    const url = process.env.REACT_APP_UNITY_API2_URL;

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
    };

    axios
      .post(url + ':3001/v1/store/alert/add', data)
      .then(response => {
        let result = response.data;
        if (result.error == true && result.message != 'Success') {
          alert('Duplicate Email');
          return;
        }
      })
      .catch(error => {
        alert(error);
      });
  };

  changeHandler = e => {
    let { name, value } = e.target;

    this.setState({
      [name]: value,
    });
  };

  handleSubmit = event => {
    event.preventDefault();
    const user = StorageService.getSession('user_info');
    const comp = StorageService.getSession('selected_org');
    const url = process.env.REACT_APP_UNITY_API2_URL;

    if (this.state.isGlobal) {
      if (!this.state.isEdit) {
        this.create(user, comp, url);
      } else {
        this.update(user, comp, url);
      }
    } else {
      this.add(user, comp, url);
    }
  };

  create(user, comp, url) {
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      email: this.state.email,
      report_type: this.state.report_type,
      store_id: this.state.store_id,
      added_by: user.email,
    };

    axios
      .post(url + ':3001/v1/store/alert/add', data)
      .then(response => {
        const result = response.data;
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false);
          return;
        }

        this.props.closeModal(
          <MdDone />,
          'Email Alert added successfully.',
          'success',
          false,
        );
      })
      .catch(error => {
        if (error == 'Bad Request') {
          alert('Duplicate Email Alert');
        } else {
          alert(error);
        }
      });
  }

  render() {
    return (
      <Form className="AuthForm" onSubmit={this.handleSubmit}>
        <ModalHeader toggle={this.props.onToggleModal()}>
          Email Alert {this.state.isGlobal ? 'Details' : 'List'}
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={12}>
              <FormGroup>
                <Label>Email</Label>
                <Input
                  type="email"
                  name="email"
                  value={this.state.email}
                  onChange={this.changeHandler}
                  required
                />
              </FormGroup>
              <FormGroup>
                <Label>Report Type</Label>
                <Input
                  type="select"
                  name="report_type"
                  value={this.state.report_type}
                  onChange={this.changeHandler}
                  required
                >
                  <option></option>
                  <option value="Order Summary">Order Summary</option>
                  <option value="Individual Order">Individual Order</option>
                </Input>
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button
            className="theme-button theme-button-secondary"
            onClick={this.props.onToggleModal()}
          >
            Close
          </Button>
          <Button className="theme-button theme-button-primary" type="submit">
            Save
          </Button>
        </ModalFooter>
      </Form>
    );
  }
}

export default PosEmailAlertForm;
